// extracted by mini-css-extract-plugin
export default {"DashboardWrap":"DashboardWrapper_DashboardWrap__Op8Ih","main_body":"DashboardWrapper_main_body__ayXij","main_body_secnd":"DashboardWrapper_main_body_secnd__wRyOt"};